export default __webpack_public_path__ + "static/media/audioAlert.630af341.mp3";